export const FILE_UPLOAD_LIMIT = 100000000; // 100 MB in bytes
export const FILE_UPLOAD_LIMIT_BULK = 10000000; // 10 MB in bytes
export const TOTAL_UPLOAD_LIMIT_BULK = 50000000; // 50 MB in bytes
export const FILE_UPLOAD_LIMIT_MB: number = FILE_UPLOAD_LIMIT_BULK / Math.pow(1000, 2); // FILE_UPLOAD_LIMIT in bytes
